<template>
  <div class="ly-input-wrap">
    <!-- 关键：增加 ref="myInput" -->
    <Input
      ref="myInput"
      v-model="inputLable"
      :loading="loading"
      placeholder="请输入"
      @on-change="handleInput"
      @on-blur="onBlur"
      @on-focus="onFocus"
    >
      <template #append>
        <Icon @click="clickDown" type="ios-arrow-down" />
      </template>
    </Input>

    <!-- 下拉列表 -->
    <ul v-if="showDrop && list.length" class="ly-drop">
      <li
        v-for="item in list"
        :key="item.value"
        class="ly-drop-item"
        @click="selectItem(item)"
      >
        <span>{{ item.label }}</span>
        <span style="margin-left: auto; color: #999">{{ item.remark }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: "" // 自身默认空值
    },
    label: {
      type: [String, Number, Function],
      default: ""
    },
    data: Function, // 获取列表的方法
    limit: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      inputVal: this.value,
      inputLable: this.showLabel(),
      orginValue: this.value,
      orginLabel: this.showLabel(),
      list: [],
      loading: false,
      showDrop: false,
      timer: null
    };
  },
  watch: {
    // 父组件修改 value 时同步到输入框
    value(val) {
      this.inputVal = val;
      this.findLabel();
    }
  },
  methods: {
    showLabel() {
      //console.log("nadas", typeof this.label);
      if (this.label) {
        if (typeof this.label == "function") {
          return this.label();
        } else {
          return this.label;
        }
      } else {
        return this.value;
      }

      //return this.label ? this.label : this.value;
    },
    onBlur() {
      // 失去焦点隐藏下拉
      setTimeout(() => {
        this.showDrop = false;

        if (this.limit) {
          this.inputVal = this.orginValue;
          this.inputLable = this.orginLabel;
          this.$emit("input", this.inputVal);
        } else {
          //this.$emit("input", this.inputVal);
        }

        //this.$emit("row", item); // 向外抛出完整对象
      }, 200);
    },
    findLabel() {
      this.inputLable = this.showLabel();
    },
    clickDown() {
      this.showDrop = true;
      this.loadList(); // 聚焦时默认加载数据
      this.$refs.myInput.focus();
    },
    // 获得焦点时，移除参数，直接拿ref
    onFocus() {
      this.$nextTick(() => {
        // 获取iView内部原生input
        const inputDom = this.$refs.myInput.$refs.input;
        // 延时兜底，确保选中生效
        setTimeout(() => {
          inputDom.select();
        }, 0);
      });
    },
    handleInput() {
      clearTimeout(this.timer);
      if (!this.limit) {
        this.$emit("input", this.inputLable);
      }

      if (!this.inputLable.trim()) {
        console.log("空了");
        if (this.multiple) {
          this.orginValue = null;
          this.orginLabel = "";
          this.$emit("input", []);
          this.$emit("row", {
            label: ""
          });
        } else {
          this.orginValue = null;
          this.orginLabel = "";
          this.$emit("input", "");
          this.$emit("row", {
            label: ""
          });
        }
      }

      // 防抖请求
      this.timer = setTimeout(async () => {
        await this.loadList();
      }, 300);
    },

    async loadList() {
      if (typeof this.data !== "function") return;
      this.loading = true;
      try {
        // 把当前输入值传给查询方法，支持搜索
        let res = await this.data(this.inputLable);
        this.list = res || [];
        this.showDrop = this.list.length > 0;
      } finally {
        this.loading = false;
      }
    },

    selectItem(item) {
      // 选择后同步值并关闭下拉

      if (this.multiple) {
        this.$emit("input", [item.value]);
        this.$emit("row", item);
      } else {
        this.inputVal = item.value;
        this.inputLable = item.label;
        this.orginValue = item.value;
        this.orginLabel = item.label;
        this.$emit("input", item.value);
        this.$emit("row", item); // 向外抛出完整对
        this.showDrop = false;
      }
    }
  },
  // 组件销毁时清除定时器，防止内存泄漏
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>

<style scoped>
.ly-input-wrap {
  position: relative;
}
.ly-drop {
  position: absolute;
  top: 38px;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  z-index: 999;
  max-height: 200px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
}
.ly-drop-item {
  padding: 8px 12px;
  line-height: 1.4;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.ly-drop-item:hover {
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/lyInput.vue